import { render, staticRenderFns } from "./ProductsCommonNumberField.vue?vue&type=template&id=efc016b4"
import script from "./ProductsCommonNumberField.vue?vue&type=script&lang=ts"
export * from "./ProductsCommonNumberField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports